import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function tooltipContent(): ComponentStyle {
  return {
    componentName: 'tooltipContent',
    baseStyle: {
      color: '#ffffff'
    }
  };
}
